import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQ = () => {
  const faqs = [{
    question: 'How Can I Contact Customer Support?',
    answer: 'You can reach us by email at bijayathakur8098@gmail.com or by phone at 0800 055 4969. Our support team is available Monday to Friday from 9 am to 5 pm. Messages received outside these hours will be responded to on the next working day.'
  }, {
    question: 'When Does My Service Plan Start and End?',
    answer: 'Your Realmpoint coverage begins as soon as your payment is confirmed. For example, if you purchase a 12-month plan on 15 July, your protection lasts until 23:59 on 14 July the following year. Your plan activates immediately after payment clears, and a confirmation email will be sent straight away. No further action is needed on your part.'
  }, {
    question: 'How Do I Request a Repair?',
    answer: 'Contact Realmpoint at 0800 055 4969 or bijayathakur8098@gmail.com. We typically schedule repair appointments within 24 to 48 hours.'
  }, {
    question: "What Does 'Unlimited Repairs' Mean?",
    answer: 'You may request unlimited repair visits and technician time for all essential appliances and systems covered under your Realmpoint plan (such as your washing machine, boiler, or drainage system). Please note: Appliances older than 10 years, accidental or liquid damage, and general wear and tear not caused by mechanical or electrical faults are excluded.'
  }, {
    question: 'What About Cooling-Off and Refunds?',
    answer: 'Yes. You can cancel within 14 days of purchase for a full refund, provided no repair work has started. Cancellations made between days 15 and 28 may be eligible for a partial refund, at our discretion, taking into account any services already rendered. No refunds are offered after 28 days. To cancel, email bijayathakur8098@gmail.com or call 0800 055 4969 with your order number. Refunds will be processed to your original payment method within 7 to 10 working days.'
  }, {
    question: 'What Appliances and Faults Are Covered?',
    answer: 'Included: Mechanical and electrical faults on registered appliances (e.g., breakdowns, faulty components for your washing machine, boiler, or drainage system). Excluded: Accidental or liquid damage, unregistered appliances, and appliances exceeding the age limit.'
  }, {
    question: 'How Quickly Can I Book an Appointment?',
    answer: 'We aim to respond within 48 hours to arrange a visit. Most local repairs are booked within 3 to 5 working days. For remote locations or busy periods, scheduling may take longer, but we will discuss alternative timings with you.'
  }, {
    question: 'Do You Cover the Whole UK?',
    answer: 'Yes. Our services cover England, Scotland, and Wales. Please check availability for remote postcodes before purchasing.'
  }, {
    question: 'What If a Repair Does Not Resolve the Fault?',
    answer: 'Contact Realmpoint immediately. If the issue cannot be fixed after reasonable attempts, you may qualify for a pro-rated refund or replacement credit for faults reported within three years.'
  }, {
    question: 'What Payment Methods Do You Accept?',
    answer: 'We accept credit and debit cards (Visa, Mastercard), Apple Pay and Google Pay, BACS or Direct Debit, and cheques (by post, please contact us for details). All payments are processed in GBP upon confirmation.'
  }];
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full" data-id="element-299">
      {/* Header Section */}
      <section className="relative py-20 bg-[#1A5F7A]" data-id="element-300">
        <div className="container mx-auto px-4" data-id="element-301">
          <div className="text-center" data-id="element-302">
            <h1 className="text-4xl font-bold text-white mb-4" data-id="element-303">
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-304">
              Find answers to common questions about our services
            </p>
          </div>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="py-16" data-id="element-305">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-306">
          <p className="text-lg text-gray-600 mb-12 text-center" data-id="element-307">
            Here you'll find answers to common questions about Realmpoint's
            appliance and system repair services and service plans. We aim to be
            as transparent as possible to give you complete peace of mind.
          </p>
          <div className="space-y-4" data-id="element-308">
            {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-309">
                <button className="w-full flex justify-between items-center p-4 bg-white text-left focus:outline-none" onClick={() => toggleFAQ(index)} data-id="element-310">
                  <span className="text-lg font-medium text-[#1A5F7A]" data-id="element-311">
                    {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-[#159895]" data-id="element-312" /> : <ChevronDownIcon className="w-5 h-5 text-[#159895]" data-id="element-313" />}
                </button>
                {openIndex === index && <div className="p-4 bg-[#f0f9ff] border-t border-gray-200" data-id="element-314">
                    <p className="text-gray-600" data-id="element-315">{faq.answer}</p>
                  </div>}
              </div>)}
          </div>
          <div className="mt-12 bg-white p-6 rounded-lg shadow-md border-l-4 border-[#159895]" data-id="element-316">
            <h3 className="text-xl font-bold text-[#1A5F7A] mb-4" data-id="element-317">
              Still Have Questions?
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-318">
              If you couldn't find the answer to your question, please don't
              hesitate to contact our friendly customer support team.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-319">
              <a href="tel:08000554969" className="bg-[#1A5F7A] text-white py-3 px-6 rounded-md text-center hover:bg-[#159895] transition-colors duration-300" data-id="element-320">
                Call Us: 0800 055 4969
              </a>
              <a href="mailto:bijayathakur8098@gmail.com" className="bg-white border border-[#1A5F7A] text-[#1A5F7A] py-3 px-6 rounded-md text-center hover:bg-[#f0f9ff] transition-colors duration-300" data-id="element-321">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default FAQ;